import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { CurrencyInputDirective } from 'src/app/currency-input.directive';


// IMPORT MODULES
import { SharedModule } from '../../shared.module';
import { MaterialsModule } from '../../materials.module';
import { LabourJobRoutingModule } from './labour-job-routing.module';
import { MainJobModule } from '../../jobs/main-job/main-job.module';


// IMPORT COMPONENTS

import { LabourJobComponent } from './labour-job.component';
import { LabourJobCreateEditComponent } from './../labour-job-create-edit/labour-job-create-edit.component';
import { LabourJobListComponent } from './../labour-job-list/labour-job-list.component';
import { LabourJobViewComponent } from './../labour-job-view/labour-job-view.component';
import { LabourTimeSheetComponent } from '../labour-time-sheet/labour-time-sheet.component';
import { LabourJobCreateComponent } from '../labour-job-create/labour-job-create.component';

import { MainFolderModuleModule } from 'src/app/folder/main-folder-module/main-folder.module';

@NgModule({
  declarations: [
    LabourJobComponent,
    LabourJobCreateEditComponent,
    LabourJobListComponent,
    LabourJobViewComponent,
    LabourTimeSheetComponent,
    // CurrencyInputDirective,
    LabourJobCreateComponent,

  ],
  imports: [
    CommonModule,
    LabourJobRoutingModule,
    SharedModule,
    MaterialsModule,
    MainFolderModuleModule,
    MainJobModule
    // MatMenuTrigger
  ],
  exports: [
    LabourJobCreateEditComponent,
    LabourJobListComponent,
    LabourJobViewComponent,
    LabourTimeSheetComponent,

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LabourJobModule { }
